import { useEffect, useRef } from "react";
import { playChatDone, playChatNeedsInput } from "../lib/sounds";

type StatusState = "waiting" | "building" | "thinking" | "loading" | "resting";

export function useChatSounds(
  statusState: StatusState,
  isTypewriterAnimating: boolean,
  enabled: boolean
): void {
  const prevState = useRef<StatusState | null>(null);
  const wasAnimating = useRef(false);
  const hadActivity = useRef(false);

  useEffect(() => {
    const prev = prevState.current;
    prevState.current = statusState;

    if (!enabled || prev === null) return;

    if (statusState === "waiting" && prev !== "waiting") {
      playChatNeedsInput();
      return;
    }

    if (statusState !== "resting") {
      hadActivity.current = true;
      return;
    }

    if (hadActivity.current && !isTypewriterAnimating) {
      hadActivity.current = false;
      playChatDone();
    }
  }, [statusState, isTypewriterAnimating, enabled]);

  useEffect(() => {
    const prev = wasAnimating.current;
    wasAnimating.current = isTypewriterAnimating;

    if (!enabled || !prev) return;

    // Only play when typewriter stops, status is resting, and there was activity
    if (
      !isTypewriterAnimating &&
      statusState === "resting" &&
      hadActivity.current
    ) {
      hadActivity.current = false;
      playChatDone();
    }
  }, [isTypewriterAnimating, enabled, statusState]);
}
